export const KMS_KEY_REVOKE_FAILURE = 'event:kms:key:revoke:encryption:failure';
export const KMS_KEY_REVOKE_ERROR_STATUS = 405;
export const KMS_KEY_REVOKE_ERROR_CODES = [405005, 405006];
